export default __webpack_public_path__ + "static/s04-00c4a9b41457616825c0a91be2a7b854.png";